import {
  FETCH_CITY_EVENTS,
  FETCH_CITY_EVENTS_SUCCESS,
  FETCH_CITY_EVENTS_FAILED,
  SAVE_CITY_EVENT,
  SAVE_CITY_EVENT_SUCCESS,
  SAVE_CITY_EVENT_FAILED,
  DELETE_CITY_EVENT_SUCCESS,
  FETCH_CITY_EVENT_SOURCES_SUCCESS,
  SAVE_CITY_EVENT_SOURCE_SUCCESS,
  DELETE_CITY_EVENT_SOURCE_SUCCESS,
} from "../store/types";

// City events — crowd events (concerts, matches, services, holidays) that
// call-centre agents enter and supervisors publish so drivers can position
// for the crowd. The list is a one-shot read (no listener), refreshed by the
// page; `fetchedAt` lets the page show how old it is.
const INITIAL_STATE = {
  list: [],          // sorted by start, ascending
  fetchedAt: 0,
  loading: false,
  saving: false,
  error: { flag: false, msg: null },
  sources: {},       // /city_events_sources (phase 4, admin): { id: { kind, name, enabled, url, venue, lastRun, lastResult } }
  sourcesFetchedAt: 0,
};

const sortByStart = (list) => list.slice().sort((a, b) => (Number(a.start) || 0) - (Number(b.start) || 0));

export const cityeventsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CITY_EVENTS:
      return { ...state, loading: true, error: { flag: false, msg: null } };
    case FETCH_CITY_EVENTS_SUCCESS:
      return { ...state, list: sortByStart(action.payload.list || []), fetchedAt: action.payload.fetchedAt || Date.now(), loading: false };
    case FETCH_CITY_EVENTS_FAILED:
      return { ...state, loading: false, error: { flag: true, msg: action.payload } };
    case SAVE_CITY_EVENT:
      return { ...state, saving: true, error: { flag: false, msg: null } };
    case SAVE_CITY_EVENT_SUCCESS: {
      const ev = action.payload;
      const rest = state.list.filter((e) => e.id !== ev.id);
      return { ...state, list: sortByStart(rest.concat([ev])), saving: false };
    }
    case FETCH_CITY_EVENT_SOURCES_SUCCESS:
      return { ...state, sources: action.payload.sources || {}, sourcesFetchedAt: action.payload.fetchedAt || Date.now() };
    case SAVE_CITY_EVENT_SOURCE_SUCCESS:
      return { ...state, sources: { ...state.sources, [action.payload.id]: action.payload.source } };
    case DELETE_CITY_EVENT_SOURCE_SUCCESS: {
      const next = { ...state.sources };
      delete next[action.payload];
      return { ...state, sources: next };
    }
    case SAVE_CITY_EVENT_FAILED:
      return { ...state, saving: false, error: { flag: true, msg: action.payload } };
    case DELETE_CITY_EVENT_SUCCESS:
      return { ...state, list: state.list.filter((e) => e.id !== action.payload), saving: false };
    default:
      return state;
  }
};
